const UNDEFINED = 'undefined';
const STORAGE = 'sessionStorage';

function setStorage(key: string, value: any) {
  if (typeof window === UNDEFINED) return;
  window[STORAGE].setItem(key, value);
}

function getStorage(key: string) {
  if (typeof window === UNDEFINED) return;

  const result = window[STORAGE].getItem(key);
  if (!!result && result !== UNDEFINED) {
    return JSON.parse(result);
  }

  return undefined;
}

function clearStorage() {
  if (typeof window === UNDEFINED) return;
  window[STORAGE].clear();
}

function removeFromStorage(key) {
  if (typeof window === UNDEFINED) return;
  window[STORAGE].removeItem(key);
}

function getFromLocalStorage(key) {
  if (typeof window === UNDEFINED) return;

  const result = window.localStorage.getItem(key);
  if (!!result && result !== UNDEFINED) {
    return result;
  }
  return undefined;
}

export { setStorage, getStorage, clearStorage, removeFromStorage, getFromLocalStorage };
